import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpProvider } from '../../common/http/http-provider.service';
import { DashboardModel } from '../../../features/home/model/dashboard.entity';
import { ProjectDetails } from '../../../features/project/model/project-details';

@Injectable()
export class DashboardRepository extends HttpProvider {
  constructor(http: HttpClient) {
    super(http);
  }

  getAll(params){
    return this.get('dashboard/allProjects',params);
  }

  updateDetails(model:ProjectDetails){
    return this.put('project/Update',model);
  }

  getApprovalList() {
    return this.get('project/approvalList');
  }

  getAllGoalsResult(params) {
    return this.get('dashboard/allGoalsNResult',params);
  }
}